import { useState } from "react";
import { ValuesPropType } from "../../home/types";
import { useDispatch, useSelector } from "react-redux";
import { removeVariation } from "../../cart/reducer";
import { IRootState } from "../../..";
type PropType = {
  item: ValuesPropType;
  onAddVariation: (label: string, isChecked: boolean) => void;
  currencySymbol: string;
  max: string;
  min: number;
  required:boolean;
};

const VariationCardCheckBox = ({
  item,
  onAddVariation,
  currencySymbol,
  max,
  min,
  required
}: PropType) => {
  const subCart = useSelector((state: IRootState) => state.cart.value.subCart);
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);

  const length = subCart?.menu_variation.length;

  const onChecked = (label: string) => {
    setIsChecked(!isChecked);
    onAddVariation(label, !isChecked); // Pass the label and the new isChecked state
    !isChecked ? dispatch(removeVariation(label)) : dispatch(removeVariation(label)); // Ensure removeVariation uses label
  };

  return (
    <div className="md:pl-10">
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <label className="">
            <input
              type="checkbox"
              className="checkbox-input accent-primary"
              checked={isChecked}
              onChange={() => onChecked(item.label)}
              max={max}
              min={min}
              required={required}
              disabled={item.max === Number(max) && !isChecked}
            />
          </label>
          <div className="text-[#727272] text-sm font-normal">{item.label}</div>
        </div>
        <div className="flex items-center gap-3">
          {item.optionPrice !== 0 && (
            <div className="text-[#727272] text-sm font-normal">
              +{currencySymbol} {item.optionPrice}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VariationCardCheckBox;
